const holds = new Set();

// Reviews have transient input and results. Let their error boundary offer an
// explicit reload instead of letting a failed import discard the current run.
export function holdAutomaticChunkReload() {
    const hold = Symbol();
    holds.add(hold);
    return () => holds.delete(hold);
}

export function installChunkReloadHandler(target = window) {
    const onError = (event) => {
        if (event.defaultPrevented || holds.size) return;
        const key = "vite-preload-reloaded-at";
        const now = Date.now();
        try {
            if (now - Number(target.sessionStorage.getItem(key) || 0) < 10_000) return;
            target.sessionStorage.setItem(key, String(now));
        } catch {
            // Without the loop guard, leave recovery to the calling surface.
            return;
        }
        event.preventDefault();
        target.location.reload();
    };
    target.addEventListener("vite:preloadError", onError);
    return () => target.removeEventListener("vite:preloadError", onError);
}
